<template>
  <SettingComponentPage title="休日カレンダー" summary="法定休日、毎週の会社休日、日付ごとの休日を設定します。">
    <HolidayCalendarSettings/>
  </SettingComponentPage>
</template>

<script>
import SettingComponentPage from './SettingComponentPage.vue'
import HolidayCalendarSettings from '../HolidayCalendarSettings.vue'

export default {
  name: 'HolidayCalendarEdit',
  components: { SettingComponentPage, HolidayCalendarSettings }
}
</script>
